import React, {Component} from 'react'
import Button from "./button";
import {connect} from 'react-redux';
import {requestGetGroupsOfSolicitors} from "../actions/groups";
import {changeAgentsListSettings} from "../actions/agentsList";
import {requestPatchExistingSolicitor} from "../actions/newSolicitor";
import { LEGAL_ADVICE_TEXT } from '../helpers/variables';   
import {FormGroup, Heading} from 'arag-ui-lib';
import {FORM_GROUP_VARIANTS} from '../helpers/formGroupVariants';
import CONTENT_STRINGS from '../helpers/contentStrings';
import { formatSolicitorOptionLabel } from '../helpers/functions';
import { HEADING_2 } from '../helpers/constants';
import SolicitorFirmSearchSelect from './solicitorFirmSearchSelect';

class ChangeSolicitorsLawsysAgent extends Component{

    componentWillMount() {
        this.props.requestGetGroupsOfSolicitors();
    }

    attachSolicitorFirm = (lawsys) => {
        let solicitorGroups = this.props.groups.solicitorGroups.data;
        let exists = false;

        loop:
            for (let i = 0; i < solicitorGroups.length; i++) {
                if (solicitorGroups[i].hasOwnProperty('solicitors')) {
                    for (let j = 0; j < solicitorGroups[i].solicitors.length; j++) {
                        if (solicitorGroups[i].solicitors[j].lawsysFirmId === parseInt(lawsys.lawsysId)) {
                            exists = true;
                            break loop
                        }
                    }
                }
            }

        if(exists){
            let selectedSolicitors = this.props.selectedSolicitorUsers;
            for (let index in selectedSolicitors) {
                this.props.requestPatchExistingSolicitor({lawsysId:this.props.selectedLawsysId, userId: selectedSolicitors[index].userId}, selectedSolicitors[index].userId)
            }
        }
        else this.props.changeAgentsListSettings('solicitorNotInGroup', true)
    };

    attachLawsysPayload = (props, selectedSolicitors, newLawsysId) => {
        const newFirm = this.props.AgentsList.selectedLawsys;

        let solicitors = [];
        for (let index in selectedSolicitors) {
            solicitors.push(selectedSolicitors[index].username)
        }
        return {
            agentUserName: solicitors,
            lawsysId: newLawsysId,
            lawsysName: newFirm.lawsysName,
            addressLine1: newFirm.addressLine1,
            postcode: newFirm.postcode
        }
    };

    madeChanges = () => {
        const newFirm = this.props.AgentsList.selectedLawsys;
        return formatSolicitorOptionLabel({ label: newFirm.lawsysName, aragProvider: newFirm.aragProvider });
    };

    onLawsysFirmChange = (selectedOption) => {
        if (!selectedOption) return;
        this.props.SelectLawsysId({
            allFirms: [{id: selectedOption.value, address: selectedOption.address, postcode: selectedOption.postcode}],
            id: selectedOption.value,
            name: selectedOption.label,
            aragProvider: selectedOption.aragProvider
        });
    };

    render(){
        const newFirm = this.props.AgentsList.selectedLawsys;
        const selectedFirmOption = newFirm && this.props.AgentsList.selectedLawsysId !== '' && newFirm.lawsysId === this.props.AgentsList.selectedLawsysId
            ? {value: newFirm.lawsysId, label: newFirm.lawsysName, aragProvider: newFirm.aragProvider, address: newFirm.addressLine1, postcode: newFirm.postcode}
            : null;

        let distinct = [];
        for (let index in this.props.AgentsList.selectedSolicitorUsers) {
            if (!distinct.includes(this.props.AgentsList.selectedSolicitorUsers[index].lawsysId)) {
                distinct.push(
                    <ul className="unorderedListNoBulletsAndSpace" key={this.props.AgentsList.selectedSolicitorUsers[index].id}>
                        <li><b>{this.props.AgentsList.selectedSolicitorUsers[index].forename  + ' ' +  this.props.AgentsList.selectedSolicitorUsers[index].surname + ': '}</b>{formatSolicitorOptionLabel({
                            label: this.props.calculateLawsysName(this.props.AgentsList.selectedSolicitorUsers[index].lawsysId),
                            aragProvider: this.props.calculateLawsysAragProvider(this.props.AgentsList.selectedSolicitorUsers[index].lawsysId),
                        })}</li>
                    </ul>
                )
            }
        }

        return (
            <div className="agentsList-confirm-changes-modal">
                {!this.props.AgentsList.displayConfirm ?
                    <div className="appFormRefSettings-modal-content">
                        <div className="appFormRefSettings-close-button" onClick={() => this.props.DisplayModal()}></div>
                        <Heading variant={HEADING_2} title={`${CONTENT_STRINGS.CHANGE} ${LEGAL_ADVICE_TEXT} ${CONTENT_STRINGS.FIRM}`} />
                        <form className="form-horizontal">
                            <FormGroup
                                labelSize="col-sm-3"
                                inputSize="col-sm-9"
                                label={`${CONTENT_STRINGS.EXISTING} ${LEGAL_ADVICE_TEXT} ${CONTENT_STRINGS.FIRM}`}
                                variant={FORM_GROUP_VARIANTS.PLAIN}
                                inputProps={{
                                    id: "existingSolicitorFirm",
                                    name: "existingSolicitorFirm",
                                    label: distinct.map(value => value) 
                                }}
                                // formGroupTestId={""}
                            />
                            <SolicitorFirmSearchSelect
                                labelSize={"col-sm-3"}
                                inputSize={"col-sm-6"}
                                label={`${CONTENT_STRINGS.NEW} ${LEGAL_ADVICE_TEXT} ${CONTENT_STRINGS.FIRM}`}
                                instanceId={'changeSolicitorFirmSelect'}
                                onChange={this.onLawsysFirmChange}
                                value={selectedFirmOption}
                            />
                            <div className="form-group">
                                <div className="col-sm-3"></div>
                                <div className="col-sm-9 solicitor-form-modal-buttons-wrapper">
                                    <Button wrapper="btn-wrapper-forForms" clickHandler={() => this.props.DisplayConfirm()} btnType="button" btnStyle={'btn btn-primary btn-xs sharp yellow'} label={CONTENT_STRINGS.CHANGE_SOLICITOR}/>
                                    <Button wrapper="btn-wrapper-forForms" clickHandler={() => this.props.DisplayModal()} btnType="button" btnStyle={'btn btn-primary btn-xs sharp white'} label={CONTENT_STRINGS.CANCEL}/>
                                </div>
                            </div>
                        </form>
                    </div>
                    :
                    <div className="appFormRefSettings-modal-content">
                        <div className="appFormRefSettings-close-button" onClick={() => this.props.DisplayModal()}></div>
                        <div className="form-group">
                            <div className="col-sm-12">
                                {distinct.map(value => value)}{' => '}{this.madeChanges()}
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="col-sm-3">{CONTENT_STRINGS.CONFIRM_CHANGES}</div>
                            <div className="col-sm-9 solicitor-form-modal-buttons-wrapper">
                                <Button wrapper="btn-wrapper" clickHandler={() => this.attachSolicitorFirm(this.attachLawsysPayload(this.props, this.props.AgentsList.selectedSolicitorUsers, this.props.AgentsList.selectedLawsysId))}
                                        btnType="button" btnStyle={'btn btn-primary btn-xs sharp yellow'} label={CONTENT_STRINGS.CONFIRM}/>
                                <Button wrapper="btn-wrapper" clickHandler={() => this.props.DisplayModal()}
                                        btnType="button" btnStyle={'btn btn-primary btn-xs sharp white'} label={CONTENT_STRINGS.CANCEL}/>
                            </div>
                            {this.props.AgentsList.attachLawsysMsg}
                        </div>
                        {
                            this.props.AgentsList.solicitorNotInGroup ?
                                <div className="col-xs-12">
                                    <p>
                                        {`Selected ${LEGAL_ADVICE_TEXT} does not belong to any ${LEGAL_ADVICE_TEXT.toLowerCase()} ${CONTENT_STRINGS.FIRM.toLowerCase()}. Please create a new ${LEGAL_ADVICE_TEXT.toLowerCase()} ${CONTENT_STRINGS.FIRM.toLowerCase()} containing the selected ${LEGAL_ADVICE_TEXT.toLowerCase()} to proceed.`}
                                    </p>
                                    <div className="row">
                                        <div className="col-xs-12 ">
                                            <Button wrapper="btn-wrapper" clickHandler={() => this.props.changeAgentsListSettings('openNewSolicitorGroupModal', true)} btnType="button" btnStyle={'btn btn-primary btn-xs sharp white'} label={`${CONTENT_STRINGS.CREATE} ${CONTENT_STRINGS.NEW} ${LEGAL_ADVICE_TEXT} ${CONTENT_STRINGS.GROUP}`}/>
                                        </div>
                                    </div>
                                </div>
                                :
                                null
                        }
                    </div>
                }
            </div>
        )
    }
};

const mapStateToProps = (state) => {
    return {
        groups: state.groups
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        requestGetGroupsOfSolicitors: () => {
            dispatch(requestGetGroupsOfSolicitors())
        },
        changeAgentsListSettings: (key, value) => {
            dispatch(changeAgentsListSettings(key, value))
        },
        requestPatchExistingSolicitor: (solicitor, id) => {
            dispatch(requestPatchExistingSolicitor(solicitor, id))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangeSolicitorsLawsysAgent);